/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";

/**
 *
 * @export
 * @interface ReportTypeCountDTO
 */
export interface ReportTypeCountDTOOptional {
  /**
   *
   * @type {ReportType}
   * @memberof ReportTypeCountDTO
   */
  type?: ReportType;
  /**
   *
   * @type {number}
   * @memberof ReportTypeCountDTO
   */
  count?: number;
}

export interface ReportTypeCountDTO extends ReportTypeCountDTOOptional {
  /**
   *
   * @type {ReportType}
   * @memberof ReportTypeCountDTO
   */
  type: ReportType;
  /**
   *
   * @type {number}
   * @memberof ReportTypeCountDTO
   */
  count: number;
}

export interface ReportTypeCountDTOTrackedI {
  /**
   *
   * @type {ReportType}
   * @memberof ReportTypeCountDTO
   */
  type?: ReportType;
  typeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportTypeCountDTO
   */
  count?: number;
  countIsSet: boolean;
}

transformDatesMap.set(
  "ReportTypeCountDTO",
  function (model: ReportTypeCountDTO) {},
);

export type ReportTypeCountDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  type: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  count: PropertyMeta<MetaTypeBase<number>>;
}>;

export var ReportTypeCountDTOMeta: ReportTypeCountDTOMetaI =
  {} as ReportTypeCountDTOMetaI;
ReportTypeCountDTOMeta = typeMeta("ReportTypeCountDTO", {
  type: propertyMeta("type", false, true, false, ReportTypeMeta),
  count: propertyMeta("count", false, true, false, MetaTypesBase.number),
});

const metaI = ReportTypeCountDTOMeta;

registerMeta(() => {});

export class ReportTypeCountDTOTracked implements ReportTypeCountDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  type__I?: ReportType = undefined;
  typeIsSet: boolean = false;
  set type(v: undefined | ReportType) {
    if (v !== undefined) {
      this.type__I = v;
      this.typeIsSet = true;
    } else {
      this.type__I = v || undefined;
      this.typeIsSet = true;
    }
    this.changeTracker = true;
  }
  get type() {
    return this.type__I;
  }
  count__I?: number = undefined;
  countIsSet: boolean = false;
  set count(v: undefined | number) {
    if (v !== undefined) {
      this.count__I = v;
      this.countIsSet = true;
    } else {
      this.count__I = v || undefined;
      this.countIsSet = true;
    }
    this.changeTracker = true;
  }
  get count() {
    return this.count__I;
  }
  constructor(config?: ReportTypeCountDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ReportTypeCountDTOOptional,
    options?: AssignOptions,
  ): ReportTypeCountDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.type && this.typeApplyFilter(optionsRequired.filter)) {
      this.type = config.type;
      if (optionsRequired.unassign) this.typeIsSet = false;
      else this.typeIsSet = true;
    }
    if (config.count && this.countApplyFilter(optionsRequired.filter)) {
      this.count = config.count;
      if (optionsRequired.unassign) this.countIsSet = false;
      else this.countIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ReportTypeCountDTOTrackedI {
    const cloned = {} as ReportTypeCountDTOTrackedI;
    if (
      this.typeIsSetDeep() &&
      this.typeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIsSet = true;
      cloned.type = this.type;
    } else {
      //cloned.typeIsSet = false
    }
    if (
      this.countIsSetDeep() &&
      this.countApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.countIsSet = true;
      cloned.count = this.count;
    } else {
      //cloned.countIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ReportTypeCountDTOTrackedI {
    if (!this.typeApplyFilter(filter)) this.typeIsSet = false;

    if (!this.countApplyFilter(filter)) this.countIsSet = false;

    return this;
  }
  typeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportTypeCountDTOMeta.type,
      ReportTypeCountDTOMeta,
      this.type,
      this,
    );
  }
  typeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIsSet && this.typeApplyFilter(filter)) return true;

    return false;
  }
  countApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportTypeCountDTOMeta.count,
      ReportTypeCountDTOMeta,
      this.count,
      this,
    );
  }
  countIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.countIsSet && this.countApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.typeIsSetDeep(filter)) return true;
    if (this.countIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
